export const FETCH_DASHBOARDCOUNT_REQUEST = "FETCH_DASHBOARDCOUNT_REQUEST";
export const FETCH_DASHBOARDCOUNT_SUCCESS = "FETCH_DASHBOARDCOUNT_SUCCESS";
export const FETCH_DASHBOARDCOUNT_FAILURE = "FETCH_DASHBOARDCOUNT_FAILURE";
